





















































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list'


    class PageFlowRequest extends PageRequest {
        beginTime?: Date;
        endTime?: Date;
        userName: string;
        statisticalType: number;
        orderType: number;
        storeId?: number;
        constructor() {
            super();
            this.statisticalType = 1;
            this.orderType = 0;
        }
    }

    @Component({
        name: "signforLogisticsStatistical",
    })
    export default class flows extends AbpBase {
        statisticalType = Enums.StatisticalType;
        orderType = Enums.WarehouseOrderType;
        pagerequest: PageFlowRequest = new PageFlowRequest();
        packedTime: Date[] = [new Date(), new Date()];
        storeaddressList: Array<storeaddressInfo> = [];
        isDisplay: boolean = false;
        get list() {
            return this.$store.state.backSignforLogisticsStatistical.list;
        };
        get loading() {
            return this.$store.state.backSignforLogisticsStatistical.loading;
        };
        //pageChange(page: number) {
        //    this.$store.commit('packstatistical/setCurrentPage', page);
        //    this.getpage();
        //};
        //pagesizeChange(pagesize: number) {
        //    this.$store.commit('packstatistical/setPageSize', pagesize);
        //    this.getpage();
        //};

        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters

            if (this.packedTime.length > 0) {
                this.pagerequest.beginTime = this.packedTime[0];
            }
            if (this.packedTime.length > 1) {
                this.pagerequest.endTime = this.packedTime[1];
            }

            await this.$store.dispatch({
                type: 'backSignforLogisticsStatistical/getAll',
                data: this.pagerequest
            })
        }
        async searchPage() {
            this.$store.state.backSignforLogisticsStatistical.currentPage = 1;
            this.getpage();
        }
        get pageSize() {
            return this.$store.state.backSignforLogisticsStatistical.pageSize;
        }
        get totalCount() {
            return this.$store.state.backSignforLogisticsStatistical.totalCount;
        }
        get currentPage() {
            return this.$store.state.backSignforLogisticsStatistical.currentPage;
        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            this.storeaddressList.push(a);

        }
        changestatus(a: any) {
            this.pagerequest.storeId = null;
            if (a == 2) {
                this.getData();
                this.isDisplay = true;
            }
            else {
                this.isDisplay = false;
            }
        }
        columns = [{

            title: '用户名',
            sortable: true,
            key: 'userName',
            width: 211,
        }, {
            title: '日期',
            sortable: true,
            key: 'signForTime',
            width: 300,
            render: (h: any, params: any) => {
                return h('span', params.row.signForTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.signForTime)));
            }
        }, {
            title: '入库数量',
            sortable: true,
            sortMethod: function (a, b, type) {
                if (type == 'asc') {
                    return a > b ? -1 : 1;
                } else {
                    return a < b ? - 1 : 1;
                }
            },
            key: 'signForCount',
            width: 275,
            }
        ]
        async created() {
            this.getpage();
        }
    }
